<template>
  <div class="max-w-3xl mx-auto space-y-6">
    <Paragraph>
      {{ t("aup.intro") }}
      <Link href="/legal/aup.pdf">
        {{ t("aup.full_version_link") }}
      </Link>
    </Paragraph>

    <Section :title="t('aup.scope_title')">
      <ul class="list-disc list-inside space-y-2">
        <ListItem v-for="(_, index) in ourScopeList" :key="index" :text="t(`aup.scope_list[${index}]`)" />
      </ul>
    </Section>

    <Section :title="t('aup.maintenance_title')">
      <Paragraph>{{ t("aup.maintenance_text_1") }}</Paragraph>
      <Paragraph>{{ t("aup.maintenance_text_2") }}</Paragraph>
      <Paragraph>{{ t("aup.maintenance_text_3") }}</Paragraph>
    </Section>

    <Section :title="t('aup.support_title')">
      <Paragraph>{{ t("aup.support_text_1") }}</Paragraph>
      <Paragraph>{{ t("aup.support_text_2") }}</Paragraph>
      <Paragraph>{{ t("aup.support_text_3") }}</Paragraph>
    </Section>

    <Section :title="t('aup.other_title')">
      <Paragraph>{{ t("aup.other_text_1") }}</Paragraph>
      <Paragraph>{{ t("aup.other_text_2") }}</Paragraph>
    </Section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Section from "@/components/ui/Section.vue";
import Paragraph from "@/components/ui/Paragraph.vue";
import Link from "@/components/ui/Link.vue";
import ListItem from "@/components/ui/ListItem.vue";

const { t, locale, messages } = useI18n();

const ourScopeList = ((messages.value[locale.value] as any)?.aup?.scope_list as string[]) || [];
</script>
